module.exports = __webpack_public_path__ + "static/media/price_free.403e5a34.png";